import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

type Params = {
  idUser: number;
};

export const reSendRegistrationConfirmationEmail = async (params: Params) => {
  const { idUser } = params;

  const fetchURL = getM8AuthURL(
    `reSendRegistrationConfirmationEmail?idUser=${idUser}`
  );

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
